export enum AttachmentPosition {
  SectionBreak = 'section-break',
  End = 'end',
}

export const FIRST_SECTION_BREAK = 1;
export const MAX_SECTION_BREAK = 100;
